import { useEffect, useState } from 'react';

export const APP_SIDEBAR_WIDTH_TRANSITION_MS = 300;

export const APP_SIDEBAR_COLLAPSED_WIDTH = 60;
export const APP_SIDEBAR_EXPANDED_WIDTH = 250;

export const useAppSidebarExpand = ({ delayMs = APP_SIDEBAR_WIDTH_TRANSITION_MS } = {}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isAnimationFinished, setIsAnimationFinished] = useState(false);
  const overlapWidth = isExpanded ? APP_SIDEBAR_EXPANDED_WIDTH - APP_SIDEBAR_COLLAPSED_WIDTH : 0;

  useEffect(() => {
    if (!isExpanded) {
      setIsAnimationFinished(false);
      return undefined;
    }
    const id = window.setTimeout(() => setIsAnimationFinished(true), delayMs);
    return () => clearTimeout(id);
  }, [isExpanded, delayMs]);

  useEffect(() => {
    document.documentElement.style.setProperty('--app-sidebar-overlap-offset', `${overlapWidth}px`);

    return () => {
      document.documentElement.style.setProperty('--app-sidebar-overlap-offset', '0px');
    };
  }, [overlapWidth]);

  return { isExpanded, isAnimationFinished, setIsExpanded };
};
